import { Link } from "react-router-dom";
import { useSite } from "@/lib/site";

export default function StaticPage({ kind }) {
  const { tc, lang } = useSite();
  const isPrivacy = kind === "privacy";
  const title = isPrivacy
    ? tc?.footer?.privacyTitle || "سياسة الخصوصية"
    : tc?.footer?.termsTitle || "شروط الاستخدام";
  const paragraphs = (isPrivacy ? tc?.footer?.privacyText : tc?.footer?.termsText) || [];
  const backLabel = lang === "fr" ? "Retour à l'accueil" : "العودة إلى الرئيسية";

  return (
    <div className="min-h-screen bg-cream" data-testid={`static-page-${kind}`}>
      <header className="border-b border-line bg-white">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-4">
          <Link to="/" data-testid="static-home-link" aria-label="العودة إلى الرئيسية">
            <img src="/logo.jpg" alt="شعار حلاق - 7ala9" className="h-11 w-auto rounded-lg" />
          </Link>
          <Link to="/" className="text-sm font-semibold text-forest-900 transition hover:text-gold-dark">
            {backLabel}
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-5 py-14">
        <h1 className="font-head text-3xl font-extrabold text-forest-950 sm:text-4xl">{title}</h1>
        <div className="mt-8 space-y-5">
          {paragraphs.map((p, i) => (
            <p key={i} className="leading-loose text-moss" data-testid={`static-paragraph-${i}`}>
              {p}
            </p>
          ))}
        </div>
      </main>
    </div>
  );
}
